// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2q3NN","modalForm":"UpgradeEpcsModal_modalForm__Sm__C","modalFooter":"UpgradeEpcsModal_modalFooter__2s0Z1"};